class VideoJs {
  constructor(options) {
    this.defaultOptions = Object.assign(
      {
        selector: ".js-avvio-hls-video",
        autoplayClass: "js-avvio-hls-video-autoplay",
        preload: "auto",
        playsinline: true,
        fluid: true,

        // videojs-http-streaming (VHS) support, add support for HLS video not natively supported devices.
        html5: {
          vhs: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false,
        },
      },
      options
    );

    // new options object for current instance
    this.options = Object.assign({}, this.defaultOptions);
  }

  // Mute Unmute button
  handleMute(video) {
    // Find the mute button
    let videoMute = video.parentNode.querySelector(".js-avvio-video--mute-toggle");

    if (typeof videoMute != "undefined" && videoMute != null) {
      videoMute.addEventListener("mousedown", function (e) {
        e.target.classList.remove("js-avvio-video--mute-button-icon");
        e.target.classList.remove("js-avvio-video--unmute-button-icon");
        if (video.muted) {
          video.muted = false;
          e.target.classList.add("js-avvio-video--unmute-button-icon");
        } else {
          video.muted = true;
          e.target.classList.add("js-avvio-video--mute-button-icon");
        }
      });
    }
  }

  // Autoplay
  handleAutoplay(video) {
    if (!video) return false;

    const { autoplayClass } = this.options;

    const hasAutoplay = video.classList.contains(autoplayClass);
    this.options.autoplay = hasAutoplay;
  }

  // Play video only in viewport
  handleViewport(player) {
    // REF: https://videojs.com/blog/autoplay-best-practices-with-video-js/

    if (!player.play) return false;
    if (player.getAttribute("autoplay")) {
      // We can only control playback without interaction if video is mute
      // video.muted = true;
      // Play is a promise so we need to check we have it
      let playPromise = player.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          // Pause the video IF it is playing on the load and handle playback in the viewport
          // player.pause();

          let observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                // PLAY the video at more than or equal to 80% visibility
                if (entry.intersectionRatio >= 0.8 && player.paused()) {
                  player.play();
                }
                // PAUSE the video at less than or equal to 40% visibility
                else if (entry.intersectionRatio <= 0.4 && !player.paused()) {
                  player.pause();
                }
              });
            },
            { threshold: [0.4, 0.8] } // Update the threshold 1 is when the video is 100% in the viewport
          );
          observer.observe(player.el());
        });
      }
    }
  }

  initInstance(video) {
    if (!video) return false;

    // Update options before Video js init
    this.handleAutoplay(video);
    this.handleMute(video);

    // Init video js for current instance
    const player = videojs(video, this.options);

    player.on("loadstart", () => {
      this.handleViewport(player);
    });

    // Reset options
    this.options = Object.assign({}, this.defaultOptions);
  }

  init() {
    const { selector } = this.options;
    const videos = document.querySelectorAll(selector);

    if (!videos.length) return false;

    videos.forEach((video) => {
      this.initInstance(video);
    });
  }
}

const videoJs = new VideoJs();

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
	window.acf.addAction('render_block_preview/type=avvio-hero', setTimeout(() => { videoJs.init() }, 3000));
	window.acf.addAction('render_block_preview/type=avvio-image-video', setTimeout(() => { videoJs.init() }, 3000));
	window.acf.addAction('render_block_preview/type=avvio-fifty-fifty', setTimeout(() => { videoJs.init() }, 3000));
}
else {
	window.addEventListener('load', () => {
		videoJs.init();
	});
}
